import React, { useRef } from 'react';

import { Input } from '../../../../Common/DesignSystem/Input';
import { InlineInput } from '../../../../Common/DesignSystem/InlineInput';
import { DropdownItem } from '../../../../Common/DesignSystem/Input';

const InputContainer = ({ children }) => (
  <div style={{ display: 'flex', flexDirection: 'row', gap: '24px', flex: 1 }}>
    {children}
  </div>
);

const Divider = () => (
  <div style={{ width: '100%', margin: '8px auto', height: '1px', borderRadius: '2px', background: '#DFE3E8' }} />
);

const SelectInput = ({ label, field, iconName, value, options, updateSelect }) => (
  <InlineInput inputFlex={2.5} labelStyle={{ minWidth: '125px' }} iconName={iconName} dropdown label={label} value={value} dropdownLabel={options[value]} onChange={(e) => { updateSelect({ name: field, value: e.currentTarget.dataset.id }) }}>
    {options.map((option, index) =>
      <DropdownItem label={option} value={index} />
    )}
  </InlineInput>
);

export const VehicleSpecifications = ({ vehicleForm, inventoryForm, updateVehicleForm, updateSelect, vehicleOemDetails, specName, uploadSpecSheet, loadingSpec, isConvertingToVehicle }) => {
  const warrantyDateRef = useRef();
  const availableDateRef = useRef();
  const retireDateRef = useRef();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <h4 style={{ marginBottom: '8px' }}>Vehicle Specifications</h4>

      <InputContainer>
        <SelectInput label="ENGINE" iconName="Engine" field="engine" value={vehicleForm.engine} options={vehicleOemDetails.engine_opt} updateSelect={updateSelect} />
        <SelectInput label="TIRES" iconName="Tires" field="tires" value={vehicleForm.tires} options={vehicleOemDetails.tires_opt} updateSelect={updateSelect} />
      </InputContainer>

      <InputContainer>
        <SelectInput label="TRANSMISSION" iconName="Transmission" field="transmission" value={vehicleForm.transmission} options={vehicleOemDetails.trans_opt} updateSelect={updateSelect} />
        <SelectInput label="DRIVE TRAIN" iconName="Drivetrain" field="drive_train" value={vehicleForm.drive_train} options={vehicleOemDetails.drive_train_opt} updateSelect={updateSelect} />
      </InputContainer>

      <InputContainer>
        <SelectInput label="ROOF" iconName="Vehicle" field="roof" value={vehicleForm.roof} options={vehicleOemDetails.roof_opt} updateSelect={updateSelect} />
        <SelectInput label="BODY TYPE" iconName="BodyType" field="body_style" value={vehicleForm.body_style} options={vehicleOemDetails.body_style_opt} updateSelect={updateSelect} />
      </InputContainer>

      <InputContainer>
        <InlineInput label="KEYS" iconName="Keys" name="keys" value={vehicleForm.keys} onChange={updateVehicleForm} inputFlex={2.5} />
        <InlineInput label="ATTACHED DOCUMENT" iconName="Specsheet" isUpload value={specName || inventoryForm.specSheetUrl} onChange={uploadSpecSheet} accept=".pdf, .doc, .docx" loading={loadingSpec} inputFlex={2.5} />
      </InputContainer>

      <Divider />

      <h4 style={{ marginBottom: '8px' }}>Vehicle Dates</h4>

      <InputContainer>
        <InlineInput label="WARRANTY START" name="warranty_date" placeholder="MM-DD-YYYY" datepicker inputFlex={2.5} id="vehicle_form_warranty_date" trailing_ic="Calendar" value={vehicleForm.warranty_date == 'Invalid date' ? '' : vehicleForm.warranty_date} onChange={updateVehicleForm} ref={warrantyDateRef} />
        <InlineInput label="EXPECTED RETIRE DATE" name="retire_date" placeholder="MM-DD-YYYY" datepicker inputFlex={2.5} id="vehicle_form_retire_date" trailing_ic="Calendar" value={vehicleForm.retire_date == 'Invalid date' ? '' : vehicleForm.retire_date} onChange={updateVehicleForm} ref={retireDateRef} />
      </InputContainer>

      <InputContainer>
        <InlineInput required={isConvertingToVehicle} label="AVAILABLE DATE" name="available_date" placeholder="MM-DD-YYYY" datepicker inputFlex={2.5} id="vehicle_form_available_date" trailing_ic="Calendar" value={vehicleForm.available_date == 'Invalid date' ? '' : vehicleForm.available_date} onChange={updateVehicleForm} ref={availableDateRef} />
        <div style={{ flex: 1 }} />
      </InputContainer>

      <Divider />

      <InlineInput label="Description" name="description" value={vehicleForm.description} onChange={updateVehicleForm}  containerStyle={{ flexDirection: 'column', alignItems: 'start' }} inputFlex="none" />
      <InlineInput label="Accessories & Modifications" name="accessories" value={vehicleForm.accessories} onChange={updateVehicleForm} containerStyle={{ flexDirection: 'column', alignItems: 'start' }} inputFlex="none" />
    </div>
  );
};
